export default class MapBoxDynamic {
    coordinates = null;
    zoom = 11;
    isSingleLocation = false;
    map = null;
    name = null;
    locations = [];
    markers = [];

    isDesktop = false;

    lineJson = { 'type': 'FeatureCollection', 'features': [{ 'type': 'Feature', 'geometry': { 'type': 'LineString', 'coordinates': [[-58.53482839975321, -34.81500440037828], [-58.4268324530276, -34.5876824396606], [-65.501080744056, -23.7444561846391], [-65.9468984895145, -23.6631700805861], [-66.1777707967173, -25.1105481703966], [-66.0024010879306, -26.0762411882646], [-67.265969628686, -26.4779781175378], [-67.3962068100293, -24.5895972932487], [-65.5409279362862, -24.8561651002507], [-58.53482839975321, -34.81500440037828]] } }] };

    constructor(locations, zoom, name) {
        this.name = name;

        if (name === 'desktop') {
            this.isDesktop = true;
        }

        this.locations = Array.from(locations);
        const coordinates = locations.map(coord => coord.coordinates);

        this.lineJson.features[0].geometry.coordinates = coordinates;

        this.formatCoordinates(coordinates);

        if (zoom) {
            this.zoom = zoom;
        }

        if (this.isDesktop) {
            document.addEventListener("updateDynamicMap", (event) => {
                const coords = event.detail.coords;
                const zoom = event.detail.zoom ?? this.zoom;
                this.flyTo(coords[0], coords[1], zoom);
            });

            document.addEventListener("resetDynamicMap", (event) => {
                let bounds = this.coordinates.reduce(function (bounds, coord) {
                    return bounds.extend(coord);
                }, new mapboxgl.LngLatBounds(this.coordinates[0], this.coordinates[0]));

                for (const coord of this.coordinates) {
                    bounds.extend(coord);
                }

                this.map.fitBounds(bounds,
                    {
                        padding: this.getPadding(),
                        speed: 0.5,
                        curve: 1.42,
                        essential: true
                    });
            });
        }
    }

    formatCoordinates(coordinates) {
        if (!Array.isArray(coordinates)) {
            console.log('Coordinates is not an array');
            return;
        }

        if (!Array.isArray(coordinates[0])) {
            // this.isSingleLocation = true;
            this.coordinates = [coordinates];
        } else {
            // this.isSingleLocation = false;
            this.coordinates = coordinates;
        }
    }

    init() {
        this.initMap().then(() => {
            window.addEventListener("resizemap", () => {
                this.mapResize();
            });
        });

    }

    async initMap() {
        // get this from settings
        mapboxgl.accessToken = 'pk.eyJ1IjoiamFtZXMtcG5wIiwiYSI6Ikc0bVhFckUifQ.wn99C0bWhKeMSOqHCQ8Akg';

        let bounds = this.coordinates.reduce(function (bounds, coord) {
            return bounds.extend(coord);
        }, new mapboxgl.LngLatBounds(this.coordinates[0], this.coordinates[0]));

        for (const coord of this.coordinates) {
            bounds.extend(coord);
        }

        const mapSettings = {
            container: 'mapbox-' + this.name,
            style: 'mapbox://styles/james-pnp/cjui3pknm2kn81ftitqboac27',
            interactive: false,
            scrollZoom: true,
            dragRotate: false,
            boxZoom: false,
            dragPan: true,
            keyboard: {
                enabled: true,
            },
            cooperativeGestures: false,
            attributionControl: false,
            zoom: this.zoom,
            padding: this.getPadding(),
        };

        if (this.isSingleLocation) {
            mapSettings.center = this.coordinates[0];
        } else {
            mapSettings.bounds = bounds;
        }

        this.map = new mapboxgl.Map(mapSettings);


        // add the line to the map
        this.map.on('load',
            () => {
                if (this.isSingleLocation) {
                    return;
                }

                this.map.addSource('LineString', {
                    'type': 'geojson',
                    'data': this.lineJson
                });

                this.map.addLayer({
                    'id': 'LineString',
                    'type': 'line',
                    'source': 'LineString',
                    'layout': {
                        'line-join': 'round',
                        'line-cap': 'round'
                    },
                    'paint': {
                        'line-color': '#000000',
                        'line-width': 1.6,
                        'line-opacity': 0.3
                    }
                });

                this.mapResize();
            });

        // this.map.addControl(new mapboxgl.NavigationControl());
        // to here

        await this.updateMapLocations(this.locations);

        this.mapResize();
    }

    async clearMarkers() {
        for (let i = 0; i < this.markers.length; i++) {
            this.markers[i].marker.remove();
        }
    }

    async updateMapLocations(locations, type, setBounds = true) {
        console.log('updateMapLocations called with:', { locations, type, setBounds });

        await this.clearMarkers();
        console.log('Markers cleared');

        if (!locations?.length) {
            console.log('No locations provided, returning');
            return;
        }

        if (setBounds) {
            console.log('Setting bounds for locations');
            let bounds = locations.reduce(function (bounds, location) {
                console.log('Extending bounds with location:', location);
                return bounds.extend(location.coordinates);
            }, new mapboxgl.LngLatBounds(locations[0].coordinates, locations[0].coordinates));

            for (const location of locations) {
                bounds.extend(location.coordinates);
            }

            console.log('Fitting map to bounds with padding:', this.getPadding());
            this.map.fitBounds(bounds,
                {
                    padding: this.getPadding(),
                }
            );
        }

        let markers = [];
        console.log('Creating markers for', locations.length, 'locations');

        locations.forEach((location, index) => {
            const locationType = location?.type ?? type;
            console.log('Processing location:', location);

            let popup = null;
            if (!location.isAirport) {
                popup = new mapboxgl.Popup({ offset: 25 }).setHTML(`
                    <div class="SearchMapPopup w-[393px]">
                        <div class="relative aspect-[393/250] flex items-end p-5"></div>
                        <div class="flex flex-col gap-[30px] p-[30px]">
                            <div>
                                <div class="inline-flex items-center gap-x-[10px] button-solid-primary py-3 px-6 rounded text-[15px] transition duration-300">
                                    ${locationType === 'experience' ? 'Read more' : ''}
                                    ${locationType === 'location' ? 'Go to location' : ''}
                                    ${locationType === 'lodge' ? 'Go to lodge' : ''}
                                    ${locationType === 'trip' ? 'Go to trip' : ''}
    
                                    <svg width="16" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M11.8537 5.85403L7.35375 10.354C7.25993 10.4478 7.13268 10.5006 7 10.5006C6.86732 10.5006 6.74007 10.4478 6.64625 10.354C6.55243 10.2602 6.49972 10.133 6.49972 10.0003C6.49972 9.8676 6.55243 9.74035 6.64625 9.64653L10.2931 6.00028H0.5C0.367392 6.00028 0.240215 5.9476 0.146447 5.85383C0.0526785 5.76006 0 5.63289 0 5.50028C0 5.36767 0.0526785 5.24049 0.146447 5.14672C0.240215 5.05296 0.367392 5.00028 0.5 5.00028H10.2931L6.64625 1.35403C6.55243 1.26021 6.49972 1.13296 6.49972 1.00028C6.49972 0.867596 6.55243 0.740348 6.64625 0.646528C6.74007 0.552708 6.86732 0.5 7 0.5C7.13268 0.5 7.25993 0.552708 7.35375 0.646528L11.8537 5.14653C11.9002 5.19296 11.9371 5.24811 11.9623 5.30881C11.9874 5.36951 12.0004 5.43457 12.0004 5.50028C12.0004 5.56599 11.9874 5.63105 11.9623 5.69175C11.9371 5.75245 11.9002 5.80759 11.8537 5.85403Z" fill="currentColor"></path>
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                `);

                popup.on('open', () => {
                    console.log('Popup opened for location:', location.id);
                    const urlSearchParams = new URLSearchParams({
                        action: 'wp_ajax_nopriv_get_location_map_card',
                        id: location.id,
                        type: locationType,
                    });

                    console.log('Fetching content with params:', urlSearchParams.toString());
                    pegasus.fetchContent(ajaxurl + '?' + urlSearchParams.toString())
                        .then(resp => {
                            if (!resp.ok) {
                                console.error('Fetch response not OK:', resp.statusText);
                                throw Error(resp.statusText);
                            }
                            return resp.text();
                        })
                        .then(text => {
                            console.log('Content fetched successfully for location:', location.id);
                            popup.setHTML(text);

                            const searchMapPopup = popup.getElement().querySelector('.SearchMapPopup');
                            const images = popup.getElement().querySelector('.SearchMapPopup__Carousel');
                            const infoButton = popup.getElement().querySelector('.SearchMapPopup__InfoButton');

                            const slides = this.$root.querySelectorAll('.flickity-cell');

                            if (images) {
                                console.log('Initializing Flickity slider');
                                this.slider = new Flickity(images, {
                                    fade: true,
                                    on: {
                                        change: () => {
                                            this.selectedIndex = this.slider.selectedIndex;
                                            this.progress = ((this.selectedIndex + 1) / slides.length) * 100;
                                            console.log('Slider changed:', { index: this.selectedIndex, progress: this.progress });
                                        }
                                    }
                                });
                            }

                            if (infoButton) {
                                infoButton.addEventListener('click', () => {
                                    console.log('Info button clicked');
                                    if (searchMapPopup.classList.contains('SearchMapPopup--ShowDetails')) {
                                        searchMapPopup.classList.remove('SearchMapPopup--ShowDetails');
                                    } else {
                                        searchMapPopup.classList.add('SearchMapPopup--ShowDetails')
                                    }
                                });
                            }
                        })
                        .catch(error => console.error('Error fetching popup content:', error));
                });
            };

            const el = document.createElement('div');
            el.innerHTML = String.fromCharCode(65 + index);
            el.className = 'marker';
            el.dataset.pinCoordinates = location.coordinates;

            console.log('Creating marker at coordinates:', location.coordinates);

            let marker = null;
            if (location.isAirport) {
                marker = new mapboxgl.Marker(el)
                    .setLngLat(location.coordinates)
                    .addTo(this.map);
            } else {
                marker = new mapboxgl.Marker(el)
                    .setLngLat(location.coordinates)
                    .setPopup(popup)
                    .addTo(this.map);
            }

            markers.push({
                id: location?.id ? parseInt(location.id) : null,
                marker,
            });

            if (location.openPopup) {
                console.log('Opening popup for location:', location.id);
                marker.togglePopup();

                this.map.flyTo({
                    center: location.coordinates
                });
            }
        });

        if (this.type === 'trip') {
            console.log('Updating line coordinates for trip');
            let lineCoordinates = locations.map(location => location.coordinates);
            this.lineJson.setData({
                type: 'Feature',
                geometry: {
                    type: 'LineString',
                    coordinates: lineCoordinates
                }
            })
        }

        this.markers = markers;
        console.log('Updated markers array with', markers.length, 'markers');
    }

    flyTo(lng, lat, zoom) {
        try {
            if (lng !== 0 && lat !== 0) {
                this.map.flyTo({
                    center: [lng, lat],
                    zoom: zoom,
                    speed: 0.5,
                    curve: 1.42,
                    essential: true
                });
            }
        } catch (ex) {
            console.log(`flyTo error: ${ex}`);
        }
    }

    mapResize() {
        const resize = setInterval(() => {
            this.map.resize();
        }, 10);
        setTimeout(() => {
            clearInterval(resize);
        }, 1000);
    }

    getVpWidth() {
        return (window.innerWidth > 0) ? window.innerWidth : screen.width;
    };

    getPadding() {
        // adjust mapbox padding depending on the viewport width
        return this.getVpWidth() < 1300 ? 50 : 250;
    };
}

document.addEventListener("alpine:init", () => {
    Alpine.data("mapBoxDynamic", (locations, zoom, name) => new MapBoxDynamic(locations, zoom, name));
});